import ScrollOut from 'scroll-out';
import Rellax from 'rellax';

const panelCta = $(".panelctapanelcta");
const panelCardWrapper = $(".panelcta__cardWrapper");
const panelCard = $('.panelcta__card');

panelCardWrapper.each(function(index, element) {
    element == this;
    var rellax = new Rellax(element, {
        speed: 1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
    });
});

ScrollOut({
    scope: panelCardWrapper,
    targets: panelCard,
    threshold: 0.9,
    onShown: function(el) {
        el.classList.add("panelcta__card--is-flipped");
    }
});